import classNames from "classnames";
import type { MRT_ColumnDef } from "mantine-react-table-open";
import { MantineRoundedNumberCell } from "../../../../../mantine/mrt/components/cell/MantineRoundedNumberCell";
import { getColSum } from "../../../../../mantine/mrt/utils/getColSum";
import type {
  EnergyRevenuesListItem,
  GetEnergyRevenuesTableColumnParams
} from "../../../RevenueMonitoring.types";
import { CustomTableCell } from "../CustomTableCell/CustomTableCell";
import { CustomTableHeader } from "../CustomTableCell/CustomTableHeader";
import { NullCell } from "../CustomTableCell/NullCell";
import { REVENUE_TABLE_HEADER_TEXTS } from "../EnergyRevenuesTable";
import { BASE_COLUMN_GROUPS } from "../EnergyRevenuesTable.constants";
import { isFirstVisibleColumn } from "../utils/isFirstVisibleColumn";

export function getDirektvermarktungFeeColumn({
  companyId,
  dataVerificationColumns,
  dataVerificationItems,
  columnVisibility
}: GetEnergyRevenuesTableColumnParams): MRT_ColumnDef<EnergyRevenuesListItem> {
  const COLUMN_NAME = "vermarktung_fee";

  const isFirstColumn = isFirstVisibleColumn(
    COLUMN_NAME,
    columnVisibility,
    BASE_COLUMN_GROUPS.direct_marketing.children
  );

  return {
    accessorKey: COLUMN_NAME,
    header: REVENUE_TABLE_HEADER_TEXTS[COLUMN_NAME],
    size: 200,
    mantineTableHeadCellProps: {
      className: classNames({ "column-header-border-left": isFirstColumn })
    },
    mantineTableBodyCellProps: {
      className: classNames({ "column-body-border-left": isFirstColumn })
    },
    mantineTableFooterCellProps: {
      className: classNames({ "column-body-border-left": isFirstColumn })
    },
    Header: CustomTableHeader,
    Cell: ({ row, column }) => (
      <CustomTableCell
        column={column}
        companyId={companyId}
        dataVerificationColumns={dataVerificationColumns}
        dataVerificationItems={dataVerificationItems}
        row={row}
      />
    ),
    Footer: ({ table }) => {
      const colSum = getColSum(table, COLUMN_NAME);
      if (colSum === null) {
        return <NullCell />;
      }
      return <MantineRoundedNumberCell extraSpaceRight value={colSum} />;
    },
    filterVariant: "range-slider"
  };
}
